import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function DanzaAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="" style={{fontFamily: "Hammersmith One"}}></th>
                                    <th scope="col" style={{width: "30%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "30%"}}>
                                        Stagionale
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">1 corso</th>
                                    <td className={"data-cell"}>144€</td>
                                    <td className={"data-cell"}>264€</td>
                                    <td className={"data-cell"}>370€</td>
                                </tr>
                                <tr>
                                    <th scope="row">2 corsi</th>
                                    <td className={"data-cell"}>276€</td>
                                    <td className={"data-cell"}>430€</td>
                                    <td className={"data-cell"}>666€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Pacchetto OPEN <br/> <span style={{fontSize: "14px"}}>(tutti i corsi)</span></th>
                                    <td className={"data-cell"}>400€</td>
                                    <td className={"data-cell"}>650€</td>
                                    <td className={"data-cell"}>800€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>

                            <AllertIscrizione />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DanzaAccordionPrezzi